/* eslint-env browser */
import inherit from 'component-inherit';
import Query from './query';

const ua = navigator.userAgent.toLowerCase();

/**
 * Creates an Chrome instance
 */

export default function Chrome() {
  if (!(this instanceof Chrome)) {
    return new Chrome();
  }

  this.name = 'Google Chrome';
  this.uaname = 'chrome';
  this.version = ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(`${this.uaname}/`)[1]) : false;
}

/**
 * Inherits Chrome from Query
 */

inherit(Chrome, Query);



// WEBPACK FOOTER //
// ./src/modules/npm-component/user-agent/chrome.js